import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SupplierNavbar from './SuppplierNavbar';
import SupplierSidebar from './SupplierSidebar';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import './Supplier.css';
import Axios from '../../../axios/axios';
import { Card } from 'react-bootstrap';

import { useLocation } from 'react-router-dom';

function SupplierOrdersPage() {
  const { type } = useParams(); // 'requested', 'pending', 'delivered'
  const [orders, setOrders] = useState([]);
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

useEffect(() => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
}, [location]);


  useEffect(() => {
    const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));
    if (!supplierInfo) return;

    setSupplier(supplierInfo);
Axios
  .get(`/supplier/orders/${type}`, {
    headers: {
      'x-supplier-id': supplierInfo.supplierId,
    },
  })
  .then((res) => {
    setOrders(res.data);
  })
  .catch((err) => {
    console.error(`Error fetching ${type} orders:`, err);
    
  });
  

  }, [type]);
  

  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
                                        <SupplierSidebar closeSidebar={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }} />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h3 className="mb-4 text-capitalize">{type} Orders</h3>
           <div className="table-container">
  <div className="table-responsive">
    <table className="table table-bordered mb-0">
      <thead>
        <tr>
          <th>Order ID</th>
          <th>Customer</th>
          <th>Date</th>
          <th>Status</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {orders.map((order, index) => (
          <tr key={order._id}>
            <td>{order.orderNumber}</td>
            <td>Asiapart Customer {index + 1}</td>
            <td>{new Date(order.createdAt).toLocaleDateString()}</td>
            <td>{order.orderStatus}</td>
            <td>
              {order.orderItems
                .filter((item) => item.supplierId === supplier?.supplierId)
                .reduce((sum, item) => sum + (item.totalPrice || 0), 0)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierOrdersPage;
